@if (loginValid) {
  <p>Welcome to the digital warranty contract platform. Logging you in...</p>
}

@if (!loginValid) {
  <div>Access denied.
    <button routerLink="/login">Try again</button>
  </div>
}
